import React from 'react';
import { useParams } from 'react-router-dom';
import EmailFormControl from '../components/ForgotPasswordContent/EmailFormControl';
import PasswordResetForm from '../components/ForgotPasswordContent/PasswordResetForm';

const ForgotPassword = () => {
    const { token } = useParams();
    return (
        <>
              {token ? <PasswordResetForm token={token} /> : <EmailFormControl />}
        </>
    )
}

export default ForgotPassword;